import { SecondaryTabs } from "@asayinc/component-library";
import {
  Verified,
  VerifiedOutlined,
  WatchLater,
  WatchLaterOutlined,
} from "@mui/icons-material";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { Stack } from "@mui/material";

export type IssuerReportsView =
  | "share-range-analysis-events"
  | "location-analysis-events";

export const ISSUER_REPORTS_VIEW: { [key: string]: IssuerReportsView } = {
  SHARE_RANGE_ANALYSIS_EVENTS: "share-range-analysis-events",
  LOCATION_ANALYSIS_EVENTS: "location-analysis-events",
};

export function IssuerReports() {
  const { id: issuerId } = useParams() as { id: string };
  const navigate = useNavigate();
  const view = window.location.href.includes("share-range-analysis-events")
    ? ISSUER_REPORTS_VIEW.SHARE_RANGE_ANALYSIS_EVENTS
    : ISSUER_REPORTS_VIEW.LOCATION_ANALYSIS_EVENTS;

  const handleTabChange = (tab: string) => {
    if (tab === ISSUER_REPORTS_VIEW.SHARE_RANGE_ANALYSIS_EVENTS) {
      navigate(`/issuers/${issuerId}/reports/share-range-analysis-events`);
    } else {
      navigate(`/issuers/${issuerId}/reports/location-analysis-events`);
    }
  };

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pr: 6.25 }}>
      <Stack sx={{ pb: 8 }}>
        <SecondaryTabs
          sx={{ mx: "auto" }}
          tabs={[
            {
              label: "Share Range Analysis",
              value: ISSUER_REPORTS_VIEW.SHARE_RANGE_ANALYSIS_EVENTS,
              icon:
                view === ISSUER_REPORTS_VIEW.SHARE_RANGE_ANALYSIS ? (
                  <Verified style={{ color: "#1968FF" }} />
                ) : (
                  <VerifiedOutlined />
                ),
            },
            {
              label: "Location Analysis",
              value: ISSUER_REPORTS_VIEW.LOCATION_ANALYSIS_EVENTS,
              icon:
                view === ISSUER_REPORTS_VIEW.LOCATION_ANALYSIS ? (
                  <WatchLater style={{ color: "#1968FF" }} />
                ) : (
                  <WatchLaterOutlined />
                ),
            },
          ]}
          activeTab={view}
          clickHandler={handleTabChange}
        />
      </Stack>
      <Outlet />
    </ScrollContainer>
  );
}
